import React, {PropTypes} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {Link} from 'react-router';
import {push} from 'react-router-redux';
import {change} from 'redux-form';
import {I18n} from 'react-redux-i18n';
import firstBy from 'thenby';

import customer from '../../customer';
const {getActivePermissions, getUsePLUCode} = customer.selectors;

import {clearActiveLabel, deselectPetLabel, getPetLabel, saveLabelToSheet} from '../actions';
import {getActiveLogo, 
        getActivePageSize, 
        getActivePetLabel, 
        getFieldPositions, 
        getSelectedGridIndex, 
        getSelectedPetLabelId, 
        getSelectedArticleMappingId,
//        isPLUActive,
        getActiveDefinition} from '../selectors';

import CloseButton from './CloseButton';
import LabelCol2Form from './LabelCol2Form';
import LabelCol4Form from './LabelCol4Form';
import LabelCol4LrgForm from './LabelCol4LrgForm';

import * as permissions from '../../common/userPermissions';

const formName = "createLabelForm";

class CreateLabelPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fieldMapping: []
    };
  }

  componentWillMount() {
    const labelAccess = this.props.activePermissions.find((permission) => {
      return permission === permissions.ACCESS_LABELS;
    });
    if(!labelAccess)
    {
      this.props.actions.push('/labels');
    } 
    else if(this.props.selectedGridIndex < 0 || this.props.selectedPetLabelId < 0) {
      this.props.actions.push('/labels');
    } else {
      this.props.actions.getPetLabel(this.props.selectedPetLabelId, this.props.activePageSize, this.props.selectedArticleMappingId);
    }
  }

  componentWillReceiveProps(newProps) {
    if((this.props.activePetLabel !== newProps.activePetLabel) && Object.keys(newProps.activePetLabel).length !== 0) {
      const columns = newProps.fieldPositions.reduce((prev, current) => {
        return (prev.Column > current.Column) ? prev.Column : current.Column;
      });
      
      // Make sure the field positions are sorted properly
      if(columns === 0) {
        newProps.fieldPositions.sort(firstBy("Column")
                                    .thenBy("Row"));
      } else if(columns === 1) {
        newProps.fieldPositions.sort(firstBy("Row")
                                    .thenBy("Column"));
      }

      // Sort the fields into the correct order
      let labelFields = [];
      newProps.fieldPositions.forEach((position) => {
        let labelField = newProps.activePetLabel.DetailFields.find((detailField) => {
          return detailField.Key === position.Field;
        });
        labelFields.push(labelField); 
      });
      
      // Build the mapping from the ordered fields
      let fieldMapping = [];
      labelFields.forEach((detailField, index) => {
        if(detailField !== undefined)
        {
          const keyName = `Key${index}`;
          const valueName = `Value${index}`;
          const mapping = {
            name: detailField.Key,
            key: keyName,
            value: valueName
          };
          fieldMapping.push(mapping);
        }
      });
      this.setState({fieldMapping: fieldMapping});
    }
  }

  handleBack = () => {
    this.props.actions.deselectPetLabel();
    this.props.actions.clearActiveLabel();
  }
  
  handleFormSubmit = (values) => {
    this.props.actions.saveLabelToSheet(this.props.activePageSize, this.props.activePetLabel, this.state.fieldMapping, this.props.activePLU, values);
  }

  render() {
    const {activeLogoUrl, activePageSize, activePetLabel, activePLU, fieldPositions} = this.props;
    const validLabel = Object.keys(activePetLabel).length !== 0;
    let large = false;
    if(activePageSize === '195 x 66 mm')
    {
      large = true;
    }

    let columns = -1;
    let labelFields = [];
    let initialValues = {};
    if(validLabel) { 
      // We need the max column to select the proper label template
      columns = fieldPositions.reduce((prev, current) => {
        return (prev.Column > current.Column) ? prev.Column : current.Column;
      });

      // Sort the fields into the correct order
      fieldPositions.forEach((position) => {
        let labelField = activePetLabel.DetailFields.find((detailField) => {
          return detailField.Key === position.Field;
        });
        labelFields.push(labelField);
      });

      initialValues["line1"] = activePetLabel.Line1;
      initialValues["line2"] = activePetLabel.Line2;
      initialValues["plu"] = activePetLabel.PLUCode;
      initialValues["barcode"] = activePetLabel.Barcode;
      initialValues["pluKey"] = activePetLabel.PLUCodeTitle !== null ? activePetLabel.PLUCodeTitle : 'PLU';

      if(activePetLabel.Price !== null && activePetLabel.Price !== undefined)
      {
        initialValues["price"] = activePetLabel.Price;
      }

      labelFields.forEach((detailField, index) => {
        if(detailField !== undefined)
        {
          const keyName = `Key${index}`;
          const valueName = `Value${index}`;
          initialValues[keyName] = detailField.Key;
          initialValues[valueName] = detailField.Value;
        }
      });
    }
  
    return (
      <div id="wrapper"> 
        <div className="container-fluid main full-width" id="main">
          <div className="row">
            <div className="col-lg-12">
              <h1 className="float-left">{I18n.t('CREATE_LABEL')}</h1>
              <CloseButton url="/labels"/>
              <div className="back"><Link to="/pet_search" onClick={this.handleBack}>{I18n.t('BACK_SEARCH_RESULTS')}</Link></div>
            </div>
          </div>
          {!validLabel && <div className="loading"/>}
          {(validLabel && columns === 0) && 
            <LabelCol2Form activePLU={activePLU}
                           detailFields={labelFields}
                           form={formName}
                           initialValues={initialValues}
                           logoUrl={activeLogoUrl}
                           onSubmit={this.handleFormSubmit}
                           petLabel={activePetLabel}
                           submitButtonText={I18n.t('CREATE_LABEL')}
            />
          }
          {(validLabel && columns === 1 && large === false) && 
            <LabelCol4Form activePLU={activePLU}
                           detailFields={labelFields}
                           form={formName}
                           initialValues={initialValues}
                           logoUrl={activeLogoUrl}
                           onSubmit={this.handleFormSubmit}
                           petLabel={activePetLabel}
                           submitButtonText={I18n.t('CREATE_LABEL')}
            />
          }
          {(validLabel && columns === 1 && large === true) && 
            <LabelCol4LrgForm activePLU={activePLU}
                              detailFields={labelFields}
                              form={formName}
                              initialValues={initialValues}
                              logoUrl={activeLogoUrl}
                              onSubmit={this.handleFormSubmit}
                              petLabel={activePetLabel}
                              submitButtonText={I18n.t('CREATE_LABEL')}
            />
          }
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    activeLogoUrl: getActiveLogo(state),
    activeDefinition: getActiveDefinition(state),
    activePageSize: getActivePageSize(state),
    activePermissions: getActivePermissions(state),
    activePetLabel: getActivePetLabel(state),
    activePLU: getUsePLUCode(state),
    fieldPositions: getFieldPositions(state),
    selectedGridIndex: getSelectedGridIndex(state),
    selectedPetLabelId: getSelectedPetLabelId(state),
    selectedArticleMappingId: getSelectedArticleMappingId(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({change, clearActiveLabel, deselectPetLabel, getPetLabel, saveLabelToSheet, push}, dispatch)
  };
}

CreateLabelPage.defaultProps = {
  activeLogoUrl: ''
};

CreateLabelPage.propTypes = {
  actions: PropTypes.object.isRequired,
  activeDefinition: PropTypes.object.isRequired,
  activeLogoUrl: PropTypes.string,
  activePageSize: PropTypes.string.isRequired,
  activePermissions: PropTypes.array.isRequired,
  activePetLabel: PropTypes.object.isRequired,
  activePLU: PropTypes.bool.isRequired,
  fieldPositions: PropTypes.array.isRequired,
  selectedGridIndex: PropTypes.number.isRequired,
  selectedPetLabelId: PropTypes.number.isRequired,
  selectedArticleMappingId: PropTypes.number.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateLabelPage);


/** WEBPACK FOOTER **
 ** ./src/modules/labels/components/CreateLabelPage.js
 **/